import React, { Component } from "react";

import "./SponsorExplorer.css";


// import YourLogoHere from './../../../img/sponsor-logos/your-logo-here.png';
import MacEngLogo from "./../../../img/sponsor-logos/mac-eng-logo.png";
//import PetroCanadaLogo from "../../../img/sponsor-logos/Petro_canada_logo.svg";
import FordLogo from "../../../img/sponsor-logos/ford-logo.jpg";
import MESLogo from "./../../../img/sponsor-logos/mes-logo.svg";
// Platinum Sponsors
import TektronixLogo from "./../../../img/sponsor-logos/tektronix-logo.svg";
import TestforceLogo from "./../../../img/sponsor-logos/testforce-logo.png";
import NexGenLogo from "./../../../img/sponsor-logos/nexgen-logo.png";
import MagnaLogo from "./../../../img/sponsor-logos/magna-logo.png";
import EcobeeLogo from "./../../../img/sponsor-logos/ecobee-logo.png";
import CandorLogo from "./../../../img/sponsor-logos/candor-logo.png";
import WeidmullerLogo from "./../../../img/sponsor-logos/weidmuller-logo.png";
import BoothKirkLogo from "./../../../img/sponsor-logos/boothkirk-logo.png";

// Gold Sponsors
import PCBLLogo from "./../../../img/sponsor-logos/PCBL-Logo_High.png";
import TeslaLogo from "../../../img/sponsor-logos/tesla-logo.png";
import KISSoftLogo from "../../../img/sponsor-logos/kissoft-logo.png";
import AltiumLogo from "./../../../img/sponsor-logos/altium-logo.png";
import Comp1Logo from "../../../img/sponsor-logos/comp1-logo.png";
import DexoryLogo from "../../../img/sponsor-logos/dexory-logo.png";
import HexagonLogo from "../../../img/sponsor-logos/hexagon_logo.png";
import HaasLogo from "./../../../img/sponsor-logos/haas-logo.svg";
import SolidworksLogo from "./../../../img/sponsor-logos/solidworks-logo.png";
import AnsysLogo from "./../../../img/sponsor-logos/ansys-logo.webp";

// Silver Sponsors
import HumaneticsLogo from "../../../img/sponsor-logos/humanetics-logo.jpg";
import FaroLogo from "../../../img/sponsor-logos/faro-logo.png";
import LemoLogo from "../../../img/sponsor-logos/LEMO.png";
import EatonLogo from "../../../img/sponsor-logos/eaton_logo.png";
import MgChemLogo from "../../../img/sponsor-logos/mg-chemicals-logo.webp";
import JohnsonElectricLogo from "../../../img/sponsor-logos/johnsonelectric-logo.png";

import PrintingCanadaLogo from "../../../img/sponsor-logos/printing-canada-logo.png";
import VTRLogo from "./../../../img/sponsor-logos/vtr-logo.png";
import SigmaComponentLogo from "../../../img/sponsor-logos/sigmacomponent-logo.png";
import SensorProductsLogo from "../../../img/sponsor-logos/sensorproducts-logo.png";
import HakkoLogo from "./../../../img/sponsor-logos/hakko-logo.png";
import ElectroMeterLogo from "./../../../img/sponsor-logos/electro-meters-logo.png";
import ItechLogo from "./../../../img/sponsor-logos/itech-logo.png";
import AirTechLogo from "../../../img/sponsor-logos/airtech-logo.png";
import ClickBondLogo from "../../../img/sponsor-logos/clickbond-logo.png";
import WackerLogo from "../../../img/sponsor-logos/WACKER_Logo_White.png";

// Bronze Sponsors
import KvaserLogo from "./../../../img/sponsor-logos/kvaser-logo.png";
import ProtocaseLogo from "./../../../img/sponsor-logos/protocase-logo.png";
import CalspanLogo from "../../../img/sponsor-logos/calspan-logo.png";
import ADILogo from "../../../img/sponsor-logos/adi-logo.png";
import GeneralSealants from "../../../img/sponsor-logos/generalsealants-logo.png";
import SummitLaser from "../../../img/sponsor-logos/summitlaser-logo.png";
import MolexLogo from "./../../../img/sponsor-logos/molex-logo.svg";
import VintonLogo from "../../../img/sponsor-logos/vinton-logo.png";
import TexasInstrumentsLogo from "./../../../img/sponsor-logos/texasinstruments-logo.png";
import InfineonLogo from "./../../../img/sponsor-logos/infineon-logo.png";
import LemLogo from "./../../../img/sponsor-logos/lem-logo.png";
import CdeLogo from "./../../../img/sponsor-logos/cde-logo.png";
import WurthElektronikLogo from "./../../../img/sponsor-logos/wurthelektronik-logo.png";
import WagoLogo from "./../../../img/sponsor-logos/wago-logo.jpg";
import PhoenixContactLogo from "./../../../img/sponsor-logos/phoenixcontract-logo.png";
import BradyLogo from "./../../../img/sponsor-logos/brady-logo.svg";
import KalPolymersLogo from "./../../../img/sponsor-logos/kalpolymers-logo.png";
import AegisBatteryLogo from "./../../../img/sponsor-logos/AegisBattery_Logo.png"
//import BelangerLogo from "./../../../img/sponsor-logos/belanger-logo.png";

export class SponsorExplorer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      partner: [
                {
          id: 1,
          name: "Faculty of Engineering, McMaster University",
          websiteLink: "https://www.eng.mcmaster.ca/",
          img: MacEngLogo,
          description:
            "The McMaster Faculty of Engineering is known for innovative educational programming and for its research and engagement with industry and community. Focusing on Problem-Based Learning, the Faculty builds strong foundations for undergraduate and graduate students in their professional careers.",
          color: "rgb(124, 0, 0)",
        },
        {
          id: 2,
          name: "Ford Motor Company",
          websiteLink: "https://www.ford.ca/",
          img: FordLogo,
          description:
            "Ford Motor Company is a global automotive industry leader headquartered in Dearborn, Michigan. With a legacy spanning over a century, Ford is driving innovation in electric vehicles, autonomous technology, and sustainable mobility to shape the future of transportation.",
          color: "rgb(124, 0, 0)",
        },

        {
          id: 3,
          name: "McMaster Engineering Society",
          websiteLink: "https://www.macengsociety.ca/",
          img: MESLogo,
          description:
            "The McMaster Engineering Society fosters the development of well rounded undergraduate engineering students through accessible support of academics, athletics, and recreational and professional activities, while maintaining the integrity and unique traditions of the faculty society.",
          color: "rgb(124, 0, 0)",
        }
      ],
      platinum: [
        {
          id: 1,
          name: "Tektronix Name",
          websiteLink: "https://www.tek.com/en",
          img: TektronixLogo,
          description: "",
        },
        {
          id: 2,
          name: "Testforce",
          websiteLink: "https://www.testforce.com/",
          img: TestforceLogo,
          description:
            "",
        },
        {
          id: 3,
          name: "NexGen Ergonomics",
          website: "https://www.nexgenergo.com/",
          img: NexGenLogo,
          description:
            "",

        },
        {
          id: 4,
          name: "Magna",
          websiteLink: "https://www.magna.com/",
          img: MagnaLogo,
          description: "",
        },
        {
          id: 5,
          name: "Ecobee",
          websiteLink: "https://www.ecobee.com/",
          img: EcobeeLogo,
          description: "",
        },
        {
          id: 6,
          name: "Candor",
          websiteLink: "https://www.candorinc.com/",
          img: CandorLogo,
          description: "",
        },
        {
          id: 7,
          name: "Weidmuller",
          websiteLink: "https://www.weidmuller.com/",
          img: WeidmullerLogo,
          description: "",
        },
        {
          id: 8,
          name: "Composites One",
          websiteLink: "https://www.compositesone.com/",
          description:
            "",
          img: Comp1Logo,
        },
        {
          id: 9,
          name: "Booth Kirk",
          websiteLink: "",
          description:
            "",
          img: BoothKirkLogo,
        },
      ],
      gold: [
        {
          id: 1,
          name: "PCB Libraries",
          websiteLink: "https://www.pcblibraries.com/",
          img: PCBLLogo,
          description:
            "PCB Libraries is a lean and agile software company that offers unparalleled software for accurate, and amazingly efficient PCB library creation and management. Their goal is to offer the highest quality and most affordable PCB design solutions available, at the lowest cost possible. They have been actively involved in development of the IPC-7351 for many years.",
          color: "rgb(0,102,179)",
        },
        {
          id: 2,
          name: "Tesla",
          websiteLink: "https://www.tesla.com/en_ca",
          img: TeslaLogo,
          description:
            "We’re building a world powered by solar energy, running on batteries and transported by electric vehicles. Explore the most recent impact of our products, people and supply chain.",
          color: "rgb(0,0,0)",
        },
        
        {
          id: 4,
          name: "KISSoft",
          websiteLink: "https://www.kisssoft.com/en",
          img: KISSoftLogo,
          description:
            'Our software includes internationally recognized calculation standards as well as various design and optimization options, based on the experience of our customers and development engineers - according to our slogan "Sharing Knowledge".',
          color: "rgb(16, 117, 189)",
        },
        {
          id: 7,
          name: "Altium",
          websiteLink: "https://education.altium.com/",
          img: AltiumLogo,
          description:
            "Industry leading PCB design software that empowers users to design boards without limits—from single PCB to multi-board systems; from low frequency to high-speed.",
          color: "rgb(166,151,106)",
        },
        {
          id: 8,
          name: "Dexory",
          websiteLink: "https://www.dexory.com/",
          description:
            "",
          img: DexoryLogo,
        },
        
        {
          id: 9,
          name: "HexagonLogo",
          websiteLink: "https://www.hexagon.com/",
          description:
            "",
          img: HexagonLogo,
        },
        {
          id: 10,
          name: "Gene Haas Foundation",
          websiteLink: "https://www.haascnc.com/content/ghf/en/home.html",
          img: HaasLogo,
        },
        {
          id: 11,
          name: "Solidworks",
          websiteLink: "https://www.solidworks.com/",
          img: SolidworksLogo,
          description:
            "SOLIDWORKS’ is a solid modelling computer-aided design (CAD) and computer-aided engineering (CAE) computer program. The program used by industry leaders provides integrated tools for every area of product development and management. Enabling enterprises to optimize processes from concepts to manufacturing.",
          color: "rgb(209,73,67)",
        },
        {
          id: 12,
          name: "Ansys",
          websiteLink: "https://www.ansys.com/",
          img: AnsysLogo,
        },
        {
          id: 13,
          name: "Hakko",
          websiteLink: "https://www.hakko.com/english/",
          img: HakkoLogo,
          description:
            "",
        },
        {
          id: 14,
          name: "Electro-Meters",
          websiteLink: "https://www.electro-meters.com/",
          img: ElectroMeterLogo,
          description:
            "",
        },
        {
          id: 15,
          name: "iTech",
          websiteLink: "https://www.itechate.com/",
          img: ItechLogo,
          description:
            "",
        },
        {
          id: 16,
          name: "AirTech",
          websiteLink: "https://airtechintl.com/",
          img: AirTechLogo,
          description:
            "",
        },
        {
          id: 17,
          name: "ClickBond",
          websiteLink: "https://www.clickbond.com/",
          img: ClickBondLogo,
          description:
            "",
        }
      ],
      silver: [
        {
          id: 1,
          name: "Humanetics",
          websiteLink: "https://www.humaneticsgroup.com/",
          description:
            "",
          img: HumaneticsLogo,
        },
        {
          id: 2,
          name: "Faro",
          websiteLink: "https://www.faro.com/",
          description:
            "",
          img: FaroLogo,
        },
        {
          id: 3,
          name: "LEMO",
          websiteLink: "https://www.lemo.com/en",
          img: LemoLogo,
          description:
            "",
          color: "rgb(0,0,0)",
        },
        {
          id: 4,
          name: "Eaton",
          websiteLink: "https://www.eaton.com/ca/en-gb.html",
          img: EatonLogo,
          description:
            "",
          color: "rgb(0,0,0)",
        },
        {
          id: 5,
          name: "MG Chemicals",
          websiteLink: "https://mgchemicals.com/",
          img: MgChemLogo,
          description:
            "",
          color: "rgb(0,0,0)",
        },
        {
          id: 6,
          name: "Johnson Electric",
          websiteLink: "https://www.johnsonelectric.com/",
          img: JohnsonElectricLogo,
          description:
            "",
        },
        {
          id: 7,
          name: "3D Printing Canada",
          websiteLink: "https://3dprintingcanada.com/",
          img: PrintingCanadaLogo,
          description:
            "",
        },
        {
          id: 9,
          name: "VTR",
          websiteLink: "https://www.vtrfeedersolutions.com/",
          img: VTRLogo,
          description:
            "",
        },
        {
          id: 10,
          name: "Sigma Component",
          websiteLink: "https://www.sigmacomponent.com/",
          img: SigmaComponentLogo,
          description:
            "",
        },
        {
          id: 11,
          name: "Sensor Products",
          websiteLink: "https://www.sensorprod.com/",
          img: SensorProductsLogo,
          description:
            "",
        },
        {
          id: 12,
          name: "Wacker",
          websiteLink: "https://www.wackerconnect.com/about-us",
          img: WackerLogo,
          description:
            "",
        }

      ],
      bronze: [
        {
          id: 1,
          name: "Kvaser",
          websiteLink: "http://www.kvaser.com/",
          img: KvaserLogo,
        },
        {
          id: 2,
          name: "Calspan",
          websiteLink: "https://calspan.com/",
          img: CalspanLogo,
        },
        {
          id: 3,
          name: "ADI",
          websiteLink: "https://www.analog.com/en/index.html",
          img: ADILogo,
        },
        {
          id: 4,
          name: "General Sealants",
          websiteLink: "https://www.generalsealants.com/",
          img: GeneralSealants,
        },
        {
          id: 5,
          name: "Summit Laser",
          websiteLink: "https://www.summitlaser.ca/",
          img: SummitLaser,
        },
        {
          id: 6,
          name: "Molex",
          websiteLink: "https://www.molex.com/en-us/home",
          img: MolexLogo,
        },
        {
          id: 7,
          name: "Vinton",
          websiteLink: "https://www.vintonprecisiontool.com/",
          img: VintonLogo,
          description:
            "PCB Libraries is a lean and agile software company that offers unparalleled software for accurate, and amazingly efficient PCB library creation and management. Their goal is to offer the highest quality and most affordable PCB design solutions available, at the lowest cost possible. They have been actively involved in development of the IPC-7351 for many years.",
          color: "rgb(0,102,179)",
        },
        {
          id: 8,
          name: "Texas Instruments",
          websiteLink: "https://www.ti.com/",
          img: TexasInstrumentsLogo,
        },
        {
          id: 9,
          name: "Infineon",
          websiteLink: "https://www.infineon.com/",
          img: InfineonLogo,
        },
        {
          id: 10,
          name: "LEM",
          websiteLink: "https://www.lem.com/",
          img: LemLogo,
        },
        {
          id: 11,
          name: "CDE",
          websiteLink: "https://www.cde.com/",
          img: CdeLogo,
        },
        {
          id: 12,
          name: "Wurth Elektronik",
          websiteLink: "https://www.we-online.com/",
          img: WurthElektronikLogo,
        },
        {
          id: 13,
          name: "WAGO",
          websiteLink: "https://www.wago.com/",
          img: WagoLogo,
        },
        {
          id: 14,
          name: "Phoenix Contact",
          websiteLink: "https://www.phoenixcontact.com/",
          img: PhoenixContactLogo,
        },
        {
          id: 15,
          name: "Brady",
          websiteLink: "https://www.bradyid.com/",
          img: BradyLogo,
        },
        {
          id: 16,
          name: "Kal-Polymers",
          websiteLink: "https://www.kalpolymers.com/",
          img: KalPolymersLogo,
        },
        {
          id: 17,
          name: "Aegis battery",
          websiteLink: "https://www.aegisbattery.com/",
          img: AegisBatteryLogo,
        },
      ],
    };
  }

  render() {
    return (
      <div className="sponsor-explorer-container">
        <section className="partners-section">
          <div className="partners-header">
            <h1 className="sponsor-type-heading">
              <span>Official EV Partners</span>
            </h1>
            <p className="partners-subtitle">
              Long-term partners who make our technical growth and competition readiness possible.
            </p>
          </div>

          <div className="partners-grid">
            {this.state.partner.map((sponsor) => (
              <a
                key={sponsor.id}
                className="partner-card"
                href={sponsor.websiteLink}
                target="_blank"
                rel="noopener noreferrer"
              >
                <div className="partner-logo-wrap">
                  <img className="partner-logo" src={sponsor.img} alt={sponsor.name} />
                </div>

                <div className="partner-body">
                
                  <h3 className="partner-name">{sponsor.name}</h3>
             
                  <p className="partner-desc">{sponsor.description}</p>

                  <div className="partner-cta-row">
                    <span className="partner-cta">
                      Visit <span className="partner-cta-icon">↗</span>
                    </span>
                  </div>
                </div>
              </a>
            ))}
          </div>
        </section>

        <h1 className="sponsor-type-heading">
          <span>Platinum Sponsors</span>
        </h1>
        <div className="top-sponsor-container">
          <div className="reworked-sponsor-container"> 
            {this.state.platinum.map((sponsor) => (
              <>
                <a
                  key={sponsor.id}
                  className="reworked-sponsor"
                  href={sponsor.websiteLink}
                  target="_blank"
                  rel="noopener noreferrer"
                  data-sponsor-id={sponsor.name.toLowerCase().replace(/\s+/g, '')}
                >
                  <img
                    className="reworked-sponsors-logo" 
                    src={sponsor.img}
                    alt="platinum-sponsor"
                  />
                </a>
              </>
            ))}
          </div>
        </div>

        <h1 className="sponsor-type-heading">
          <span>Gold Sponsors</span>
        </h1>
        <div className = "top-sponsor-container">
          <div className="reworked-sponsor-container gold-sponsor-container">
          {this.state.gold.map((sponsor) => (
              <>
                <a
                  key={sponsor.id}
                  className="reworked-sponsor"
                  href={sponsor.websiteLink}
                  target="_blank"
                  rel="noopener noreferrer"
                  data-sponsor-id={sponsor.name.toLowerCase().replace(/\s+/g, '')}
                >
                  <img
                    className="reworked-sponsors-logo gold-sponsor"
                    src={sponsor.img}
                    alt="gold-sponsor"
                  />
                </a>
              </>
            ))}
          </div>
        </div>
        
        <h1 className="sponsor-type-heading">
          <span>Silver Sponsors</span>
        </h1>
        <div className = "top-sponsor-container">
          <div className="reworked-sponsor-container silver-sponsor-container">
          {this.state.silver.map((sponsor) => (
              <>
                <a
                  key={sponsor.id}
                  className="reworked-sponsor"
                  href={sponsor.websiteLink}
                  target="_blank"
                  rel="noopener noreferrer"
                  data-sponsor-id={sponsor.name.toLowerCase().replace(/\s+/g, '')}
                >
                  <img
                    className="reworked-sponsors-logo silver-sponsor"
                    src={sponsor.img}
                    alt="silver-sponsor"
                  />
                </a>
              </>
            ))}
          </div>
        </div>

        <h1 className="sponsor-type-heading">
          <span>Bronze Sponsors</span>
        </h1>
        <div className = "top-sponsor-container bronze-section">
          <div className="reworked-sponsor-container bronze-sponsor-container">
          {this.state.bronze.map((sponsor) => (
              <>
                <a
                  key={sponsor.id}
                  className="reworked-sponsor"
                  href={sponsor.websiteLink}
                  target="_blank"
                  rel="noopener noreferrer"
                  data-sponsor-id={sponsor.name.toLowerCase().replace(/\s+/g, '')}
                >
                  <img
                    className="reworked-sponsors-logo bronze-sponsor"
                    src={sponsor.img}
                    alt="bronze-sponsor"
                  />
                </a>
              </>
            ))}
          </div>
        </div>


      </div>
    );
  }
}

export default SponsorExplorer;
